import { render, staticRenderFns } from "./performanceReporting.vue?vue&type=template&id=7ec1561b&scoped=true"
import script from "./performanceReporting.vue?vue&type=script&lang=js"
export * from "./performanceReporting.vue?vue&type=script&lang=js"
import style0 from "./performanceReporting.vue?vue&type=style&index=0&id=7ec1561b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1561b",
  null
  
)

export default component.exports